// types
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { history } from '../../../helpers/history';
import { fetchWrapper } from '../../../helpers/fetch-wrapper';
import { useNavigate } from "react-router-dom";
import { authenticateUser, logoutCognito } from "../../../api/Auth"
//localStorage.removeItem('user');
// initial state
const initialState = {
  loading: false,
  // initialize state from local storage to enable user to stay logged in
  user: localStorage.getItem('user') != 'undefined' ? JSON.parse(localStorage.getItem('user')) : [],
  error: null
};

//const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

export const loginUser = createAsyncThunk(
  "user/loginUser",
  async (userCred) => {
    const request = authenticateUser(userCred.values.email, userCred.values.password)
    const response = await request;
    return response;
  }
);


// ==============================|| SLICE - USER ||============================== //

const user = createSlice({
  name: 'user',
  initialState,

  reducers: {
    logout: (state, action) => {
      state.user = null;
      localStorage.removeItem('user');
      logoutCognito();
      // async () => {
      //   const request = logout()
      //   const response = await request;
      //   return response;
      // }
     //logout;
      //history.navigate('/login');
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        //console.log(action);
        const user = action.payload;

        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));
        state.user = user;

        // get return url from location state or default to home page
        //const { from } = history.location.state || { from: { pathname: '/' } };
        //const { from } =  { from: { pathname: '/' } };
        //history.navigate(from);
      })
      .addCase(loginUser.rejected, (state, action) => {
        //onsole.log(action.error);
        state.error = action.error.message;
      })
  }
});



export const { logout } = user.actions;
export default user.reducer;